import {
  Center,
  Flex,
  FlexProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'
import React from 'react'

import { LeadText } from '~shared-components/components'
import { ModalCloseButton } from '~shared-components/components/Modal/ModalCloseButton'
import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconTrack } from '~shared-components/icons/brand/IconTrack'

import { GenericModalFooter } from '../Modal/GenericModalFooter'

export interface ConfirmLogoutModalProps {
  isOpen: boolean
  onClose: () => void
  onLogout: () => void
}

const IconWrapper: React.FC<FlexProps> = props => (
  <Flex
    alignItems="center"
    border="2px solid"
    borderColor="red.80"
    borderRadius="50%"
    display="inline-flex"
    h={20}
    justifyContent="center"
    mb={10}
    mt={4}
    w={20}
    {...props}
  />
)

export const ConfirmLogoutModal: React.FC<ConfirmLogoutModalProps> = ({
  children,
  isOpen,
  onClose,
  onLogout,
}) => {
  const t = useTranslations()
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset="scale"
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton aria-label="close" onClose={onClose} />
        <ModalBody>
          <VStack alignItems="flex-start" spacing={5} w="100%">
            <Center w="100%">
              <IconWrapper>
                <IconTrack boxSize="36px" color="red.80" />
              </IconWrapper>
            </Center>
            <LeadText>{children}</LeadText>
            <LeadText bold>{t('logout.confirmlogout')}</LeadText>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <GenericModalFooter
            actionButtonId="modal-logout-logout-btn"
            actionIcon="IconTrack"
            actionTextLabel="label.logout"
            onAction={onLogout}
            onCancel={onClose}
          ></GenericModalFooter>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
